import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { WhatsappMessageStatusResponse } from "@/types";
import { GET_WHATSAPP_MESSAGE_STATUS } from "@/constants";

export const useGetWhatsappMessageStatus = (onSuccess: () => void, onError: () => void) => {
  return useMutation<WhatsappMessageStatusResponse, AxiosError, { id: number | string }>({
    mutationFn: async ({ id }) => {
      const res = await axios.get<WhatsappMessageStatusResponse>(GET_WHATSAPP_MESSAGE_STATUS, {
        params: { id },
      });

      const data = res.data;

      if (data.status === "WAITING") {
        throw new AxiosError("WAITING status", undefined, undefined, undefined, {
          ...res,
          data,
        });
      }

      return data;
    },
    onSuccess: (data) => {
      if (data.status === "SENT") {
        onSuccess();
      } else if (data.status === "FAILED") {
        onError();
      }
    },
    retry: (_, error) => {
      const status = (error as AxiosError<WhatsappMessageStatusResponse>)?.response?.data?.status;
      return status === "WAITING";
    },
  });
};
